export const downloadFile = (base64:string, title:string) => {
    const link = document.createElement('a');
    link.download = title;
    link.href = "data:application/octet-stream;base64," + base64;
    link.click();
}
